/**
 * @file 弹窗相关
 */
import { defineStore } from 'pinia';
import { $common } from '@/config/api.ts';

interface UniversalPopList {
  activityEndTime: number
  buttonContent: string
  endTime: number
  h5_image: string
  id: number
  image: string
  popUpType: number
  startTime: number
  title: string
  url: string
  index: number
  remind?: boolean
}

export const usePopupStore = defineStore('popupStore', {
  state: () => ({
    universalPop: false,
    droguePop: false,
    universalPopList: [] as UniversalPopList[],
    drogueList: {} as UniversalPopList,
    universalTextPop: [] as any[],
    routeChangeTimer: null as number | null
  }),

  actions: {
    async getPopUpList(param: any) {
      this.droguePop = false;
      this.universalPop = false;
      this.universalPopList = [];
      this.universalTextPop = [];
      const cacheKey = (localStorage.getItem('popupList') || '').split(',');
      const res: any = await $common.popUpList(param);
      if (res.success) {

        const data = res.data.map((item: any) => {
          let key = '';
          if (item.cycle == 0 && item.popUpRepeat == 1) {
            key = [item.id, param.pageId, item.cycle, item.popUpRepeat, param.symbol].join('-');
          }
          return {
            ...item,
            key: key
          };
        }).filter((item: any) => {
          return !item.key || !cacheKey.includes(item.key);
        });
        this.universalPopList = data?.filter((e: any) => e.popUpType == 0);
        this.universalTextPop = data?.filter((e: any) => e.popUpType == 2);
        this.drogueList = data.find((e: any) => e.popUpType == 1);
        if (this.drogueList?.image) {
          this.droguePop = true;
        }

        if (this.universalPopList.length > 0) {
          this.universalPop = true;
        }
      }
    },

    async handleRouteChange(params:any) {
      // Clear any existing timer
      if (this.routeChangeTimer) {
        clearTimeout(this.routeChangeTimer);
        this.routeChangeTimer = null;
      }

      // Set new timer
      this.routeChangeTimer = window.setTimeout(async() => {
        await this.getPopUpList({ 
          pageId: params.pageId, 
          d: params.visitorId, 
          symbol: params.symbol
        });
      }, 500);
    },

    resetState() {
      this.droguePop = false;
      this.universalPopList = [];
      this.universalPop = false;
      this.universalTextPop = [];
      this.drogueList = {} as UniversalPopList;
      if (this.routeChangeTimer) {
        clearTimeout(this.routeChangeTimer);
        this.routeChangeTimer = null;
      }
    }
  }
}); 